import React, {Component} from 'react'

import styled from '@emotion/styled'

import {connect} from 'react-redux';

import {withTranslation} from "react-i18next";
import sv from "../styles/styles";
import {userService} from "../_services";
import {userActions} from "../_actions/user.actions";


// STYLE ##########################################################

const Username = styled(`div`)`
  color: ${sv.colors.grey};
`;

// COMPONENT ##########################################################

class UserInfo extends Component {

    getUser = () => {
        let userDetails = userService.getAuthUser();
        // if there is no user information, then automated log out
        if (!userDetails || !userDetails.token){
            this.props.clearAuthState();
        }
        return userDetails;
    };

    render() {
        const userDetails = this.getUser();

        return (
        <Username>
            {userDetails &&
                userDetails.username
            }
        </Username>
        )
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        clearAuthState: () => dispatch( userActions.logout() ),
    }
}

const connectedPayment = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(UserInfo));

export { connectedPayment as UserInfo };